export default "<div class=\"lds-dual-ring\"></div>"